/**
 * Service worker registration (spec §8.10).
 *
 * `virtual:pwa-register` is provided by vite-plugin-pwa at build time; the
 * dynamic import keeps it out of the module graph in tests and in dev, where
 * the plugin is disabled and the module does not exist.
 */
export async function registerServiceWorker(): Promise<void> {
  if (import.meta.env.DEV || !('serviceWorker' in navigator)) return;

  const { registerSW } = await import('virtual:pwa-register');

  registerSW({
    immediate: true,
    onRegisterError: (error: unknown) => {
      // A failed registration costs the offline shell, not the app.
      console.warn('Service worker registration failed', error);
    },
  });
}
